import { createSlice, Draft, PayloadAction } from "@reduxjs/toolkit";

interface InitialState {
  deviceWithWorstSubstanceData: any;
}

const initialState: InitialState = {
  deviceWithWorstSubstanceData: [],
};
const dahsboardSlice = createSlice({
  name: "Dashboard",
  initialState,
  reducers: {
    setDeviceWithWorstSubstanceData: (
      state: Draft<InitialState>,
      action: PayloadAction<any>
    ) => ({
      ...state,
      deviceWithWorstSubstanceData: action.payload,
    }),
  },
});

export const { setDeviceWithWorstSubstanceData } = dahsboardSlice.actions;

export default dahsboardSlice.reducer;
